import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));

// Helper: build query param for subTenantId
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers with conditional tenant-login
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": decodedToken?.tenantApiKey,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const DepartmentsApi = {
  // Create Institution
  CreateInstitutions: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .post(`/institutions`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Departments
  ListDepartments: (page, limit) => {
    return apiApp
      .get(
        `/institutions?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Get single Department
  SingleDepartments: (departmentId) => {
    return apiApp
      .get(
        `/institutions/${departmentId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update Department
  PutDepartments: (departmentId, data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .put(`/institutions/${departmentId}`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Department
  DeleteDepartments: (departmentId) => {
    return apiApp
      .delete(
        `/institutions/${departmentId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default DepartmentsApi;
